import React, { useEffect } from 'react'
import { AppToasterV2Provider, useToastV2 } from '@easyllama/ui-components'
import { useSessionStore } from '~/context/sessionStore'
import { fireTypedToastV2 } from '~/utils/toastV2Type'
import '~/tailwind-output.css'

// The app's one default-channel toast provider - never mount another AppToasterV2Provider without an id (ENG-12178).
const GlobalLayout = () => {
  const { toastMessages, setToastMessages } = useSessionStore()
  const toast = useToastV2()

  useEffect(() => {
    if (toastMessages.length === 0) return undefined

    // Clear first so a re-render can't replay the queue, then fire from the captured copy.
    const queued = toastMessages
    setToastMessages([])

    // Deferred by a macrotask so the toaster has subscribed before this fires.
    const timer = setTimeout(() => {
      queued.forEach(({ message, type }) => fireTypedToastV2(toast, type, message))
    }, 0)
    return () => clearTimeout(timer)
  }, [])

  return <AppToasterV2Provider />
}

export default GlobalLayout
